import axios from "axios";

export const DD_BASE_URL = "https://dd.aimantra.info";

let latestServerDate = null;

export const getLatestServerDate = () => latestServerDate;

export const getDdAuthHeaders = () => {
  const token = sessionStorage.getItem("access_token");
  const headers = {
    "Content-Type": "application/json",
    accept: "application/json",
  };
  if (token && token !== "null" && token !== "undefined") {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

export const getEmpCode = () =>
  sessionStorage.getItem("emp_code_hrms") ||
  sessionStorage.getItem("emp_code") ||
  null;

const ddAxios = axios.create({
  baseURL: DD_BASE_URL,
  timeout: 60000,
});

ddAxios.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("access_token");
  config.headers = {
    ...(config.headers || {}),
    accept: "application/json",
  };
  if (token && token !== "null" && token !== "undefined") {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    delete config.headers.Authorization;
  }
  if (!config.headers["Content-Type"] && !(config.data instanceof FormData)) {
    config.headers["Content-Type"] = "application/json";
  }
  return config;
});

ddAxios.interceptors.response.use(
  (response) => {
    const dateHeader = response.headers?.date;
    if (dateHeader) {
      const parsed = new Date(dateHeader);
      if (!Number.isNaN(parsed.getTime())) latestServerDate = parsed;
    }
    return response;
  },
  (error) => Promise.reject(error)
);

export const refreshServerDate = async () => {
  try {
    await ddAxios.get("/");
  } catch {
    // keep last known date if the ping fails
  }
  return latestServerDate;
};

export default ddAxios;
